import React, { useContext } from 'react'
import { getMessage } from 'lib/translator'
import { Link } from 'react-router-dom'
import ListingPage from 'containers/ListingPage'
import VoucherCampaignTableProperties from './VoucherCampaignTableProperties'
import { SplitContext } from 'containers/SplitContext'
import SPLIT_FEATURES from 'containers/SplitContext/features'
import emptyIcon from 'icons/no-orders.svg'

const ActionButtons = () => {
  const splitConfig = useContext(SplitContext)
  const { splits } = splitConfig
  const voucherCenterConfigPageBtnEnabled = splits?.[SPLIT_FEATURES.VOUCHER_CENTER_CONFIG_PAGE]?.treatment === 'on'
  return (
    <>
      {
        voucherCenterConfigPageBtnEnabled &&
        <Link to="/marketing/voucher-center-campaigns/configuration">
          <button className="primary button voucher-center-config-btn">
            Voucher Center Configuration
          </button>
        </Link>
      }
      <Link to="/marketing/voucher-center-campaigns/new">
        <button className="primary button">
          {`+ ${getMessage('offer.campaigns.listing.add.offerCampaign')}`}
        </button>
      </Link>
    </>
  )
}

const VoucherCenterCampaignsTable = ({ menu }) => {
  return (
    <ListingPage
      testid="voucher-campaign-listing"
      menu={menu}
      className="voucher-center-campaigns-page"
      title={getMessage('offer.campaigns.listing.heading')}
      api={{
        url: '/offer-service/campaigns',
        transform: (response) => response.data.campaign,
      }}
      tableDynamic
      primaryKey="id"
      tableProperties={VoucherCampaignTableProperties()}
      headerActions={ActionButtons}
      emptyState={{
        icon: emptyIcon,
        message: 'There is no voucher campaign at the moment.',
        actions: ActionButtons
      }}
      nextPrevButtonsEnabled
      dontSavePagination
    />
  )
}

export default VoucherCenterCampaignsTable
